import { useState } from "react";

const useScrollDirection = () => {
  const [previousPosition, setPreviousPosition] = useState(0);

  return scrollEntry => {
    let result = true;

    if (scrollEntry) {
      const currentY = scrollEntry.boundingClientRect.y
      const isIntersecting = scrollEntry.isIntersecting

      if (currentY > previousPosition && isIntersecting) {
        result = false;
      }

      setPreviousPosition(currentY);
    }

    return result;
  }
};

export default useScrollDirection;
